export var DEFAULT_OPTIONAL_FIELD_I18N = {
    label: 'Optional',
    ariaLabel: 'Optional field',
    srLabel: 'Optional field',
};
export var DEFAULT_REQUIRED_FIELD_I18N = {
    label: '*',
    ariaLabel: 'Required field',
    srLabel: 'Required field',
};
export var DEFAULT_SUCCESS_FIELD_I18N = {
    srLabel: 'Correct value',
};
